<form>
	<div class="tables-container">
	<table *ngIf="bp" class="table table-sm table-dark no-bottom-margin" [ngClass]="{ 'bp-print-view': printView}">
		<tbody>
			<tr bpHl="Aufnahme" [hldata]="bp" class="tborder lborder rborder">
				<th>Punktart</th>
				<td><wd-list name="Punktart" [(model)]="bp.type"></wd-list></td>
				<th>Datum</th>
				<td><wd-date *ngIf="canSeePersonalData()" name="Aufnahmedatum" [(model)]="bp.header.aufnahme.datum"></wd-date><span *ngIf="!canSeePersonalData()">–</span></td>
			</tr>
			<tr bpHl="Aufnahme" [hldata]="bp" class="lborder rborder">
				<th>Nummer</th>
				<td><wd-text name="Nummer" [(model)]="bp.header.nummer"></wd-text></td>
				<th>Kartierer</th>
				<td><wd-text *ngIf="canSeePersonalData()" name="Kartierer" [(model)]="bp.header.aufnahme.kartierer"></wd-text><span *ngIf="!canSeePersonalData()">–</span></td>
			</tr>
			<tr bpHl="Aufnahme" [hldata]="bp" class="lborder rborder">
				<th>Labornummer</th>
				<td class="full-width">
					<wd-text name="Labornummer" [(model)]="bp.header.labornummer"></wd-text>
					<span class="status-text">{{bp.header.statusLaboranalyse}}</span>
				</td>
				<ng-container *ngIf="!printView">
				<th>Projekt</th>
				<td>
					<span *ngIf="!bp.header.projects?.length" class="cell-text">Kein Projekt zugeordnet</span>
					<span *ngFor="let p of bp.header.projects" class="badge bg-secondary me-1" style="font-size: 0.85em; font-weight: normal;">
						{{ p.name }}{{ parseProjectDate(p.id) ? ' (' + parseProjectDate(p.id) + ')' : '' }}
						<button *ngIf="canRemoveProject" type="button" class="btn-close btn-close-white ms-1"
							style="font-size: 0.5em; vertical-align: middle;"
							(click)="removeProject(p.id, p.name); $event.stopPropagation()"></button>
					</span>
				</td>
			</ng-container>
			<ng-container *ngIf="printView">
				<th></th><td></td>
			</ng-container>
			</tr>
			<tr bpHl="Aufnahme" [hldata]="bp" class="bborder lborder rborder">
				<th></th>
				<td></td>
				<th></th>
				<td></td>
			</tr>
			<tr class="spacer-row"><td colspan="4"></td></tr>
			<tr bpHl="Adresse" [hldata]="bp" class="tborder lborder rborder">
				<th>Forstamt</th>
				<td><wd-list name="Forstamt" [(model)]="bp.header.forstamt"></wd-list></td>
				<th>Revier</th>
				<td><wd-list name="Revier" [(model)]="bp.header.revier"></wd-list></td>
			</tr>
			<tr bpHl="Adresse" [hldata]="bp" class="lborder rborder">
				<th>Forstbetrieb</th>
				<td><wd-text name="Forstbetrieb" [(model)]="bp.header.forstbetrieb"></wd-text></td>
				<th>Abt./UA/TF</th>
				<td class="full-width">
					<wd-text name="Abteilung" [(model)]="bp.header.adresse.abteilung"></wd-text>
					<wd-list name="Unterabteilung" [(model)]="bp.header.adresse.unterabteilung"></wd-list>
					<wd-text name="Teilfläche" [(model)]="bp.header.adresse.teilflaeche"></wd-text>
				</td>
			</tr>
			<tr bpHl="Adresse" [hldata]="bp" class="bborder lborder rborder">
				<th>Gem./Flur/FS</th>
				<td class="full-width">
					<wd-text name="Gemarkung" [(model)]="bp.header.adresse.gemarkung"></wd-text>
					<wd-number name="Flur" [(model)]="bp.header.adresse.flur"></wd-number>
					<wd-text name="Flurstück" [(model)]="bp.header.adresse.flurstueck"></wd-text>
				</td>
				<th></th>
				<td></td>
			</tr>
			<tr class="spacer-row"><td colspan="4"></td></tr>
			<tr bpHl="Naturraum" [hldata]="bp" class="tborder lborder rborder">
				<th>Wuchsgebiet</th>
				<td><wd-text name="Wuchsgebiet" [(model)]="bp.extendedHeader.wuchsgebiet"></wd-text></td>
				<th>Wuchsbezirk</th>
				<td><wd-text name="Wuchsbezirk" [(model)]="bp.extendedHeader.wuchsbezirk"></wd-text></td>
			</tr>
			<tr bpHl="Naturraum" [hldata]="bp" class="lborder rborder">
				<th>Geologie</th>
				<td class="full-width"><wd-comment-indicator [fields]="['GeologieOben', 'GeologieUnten']">
					<wd-list *ngIf="bp.extendedHeader.geologie.oben" name="GeologieOben" [(model)]="bp.extendedHeader.geologie.oben"></wd-list>
					<span *ngIf="bp.extendedHeader.geologie.oben && bp.extendedHeader.geologie.trenner">{{bp.extendedHeader.geologie.trenner}}</span>
					<wd-list *ngIf="bp.extendedHeader.geologie.trenner && bp.extendedHeader.geologie.unten" name="GeologieUnten" [(model)]="bp.extendedHeader.geologie.unten!"></wd-list>
				</wd-comment-indicator></td>
				<th>Klimastufe</th>
				<td><wd-an-list name="Klimastufe" [(model)]="bp.extendedHeader.klimaStufe"></wd-an-list></td>
			</tr>
			<tr *ngIf="isM()" bpHl="Naturraum" [hldata]="bp" class="lborder rborder">
				<th style="white-space: nowrap">Moortyp (ökol.)</th>
				<td><wd-text name="Moortyp ökologisch" [(model)]="bp.extendedHeader.moorTyp!.oekologisch"></wd-text></td>
				<th>Moortyp (hydr.)</th>
				<td><wd-text name="Moortyp hydrogenetisch" [(model)]="bp.extendedHeader.moorTyp!.hydrogenetisch"></wd-text></td>
			</tr>
			<!-- Relief-Anzeige -->
			@if (isB()) {
				<!-- B-Punkte: Zusammengefasste Relief-Anzeige -->
				<tr bpHl="Naturraum" [hldata]="bp" class="lborder rborder">
					<th>Relief</th>
					<td><wd-comment-indicator [fields]="['Neigungsstufe', 'NeigungGrad', 'Woelbung', 'Hangrichtung', 'ReliefformUmgebung', 'Hanganschluss', 'Hangteil', 'Hoehenspanne', 'InnereRauhheit', 'Reliefform']" class="cell-text">{{reliefBeschreibung()}}</wd-comment-indicator></td>
					<th>Mesoklima</th>
					<td><wd-text name="Mesoklima" [(model)]="bp.extendedHeader.mesoklima"></wd-text></td>
				</tr>
			} @else {
				<!-- M-Punkte: Moor-Relief -->
				<tr bpHl="Naturraum" [hldata]="bp" class="lborder rborder">
					<th>Relief</th>
					<td class="full-width"><wd-comment-indicator [fields]="['Relief Bestand', 'Relief Bodenvegetation']">
						<wd-list *ngIf="bp.extendedHeader.relief.reliefBestand" name="Relief Bestand" [(model)]="bp.extendedHeader.relief.reliefBestand"></wd-list>
						<span *ngIf="bp.extendedHeader.relief.reliefBestand && bp.extendedHeader.relief.reliefBodenvegetation">/</span>
						<wd-list *ngIf="bp.extendedHeader.relief.reliefBodenvegetation" name="Relief Bodenvegetation" [(model)]="bp.extendedHeader.relief.reliefBodenvegetation"></wd-list>
					</wd-comment-indicator></td>
					<th>Mesoklima</th>
					<td><wd-text name="Mesoklima" [(model)]="bp.extendedHeader.mesoklima"></wd-text></td>
				</tr>
			}
			<tr *ngIf="!isM()" bpHl="Naturraum" [hldata]="bp" class="lborder rborder">
				<th>Morphologie</th>
				<td class="full-width"><wd-comment-indicator [fields]="['Morphologie*']"><ng-container *ngFor="let m of bp.extendedHeader.morphologie; let i = index"><span *ngIf="i > 0 && m">/</span><wd-list *ngIf="m" name="Morphologie{{i}}" [(model)]="bp.extendedHeader.morphologie[i]"></wd-list></ng-container></wd-comment-indicator></td>
				<th>KMgCaP</th>
				<td><wd-list name="KMgCaP-Serie" [(model)]="bp.extendedHeader.kMgCaPSerie"></wd-list></td>
			</tr>
			<tr bpHl="Naturraum" [hldata]="bp" class="bborder lborder rborder">
				<th>Witterung</th>
				<td><wd-text name="Witterung" [(model)]="bp.extendedHeader.witterung"></wd-text></td>
				<th></th>
				<td></td>
			</tr>
			<tr class="spacer-row"><td colspan="4"></td></tr>
			<tr bpHl="Bemerkungen" [hldata]="bp" class="lborder rborder tborder">
				<th>Bestand</th>
				<td colspan="3"><wd-comment-indicator [fields]="['Bestand']" class="cell-text">{{baumarten()}}</wd-comment-indicator></td>
			</tr>
			<tr bpHl="Bemerkungen" [hldata]="bp" class="lborder rborder bborder">
				<th>Bemerkungen</th>
				<td colspan="3"><wd-comment-indicator [fields]="['Bemerkungen']" class="cell-text">{{bp.header.bemerkungen}}</wd-comment-indicator></td>
			</tr>
		</tbody>
	</table>
	</div>
</form>
